import { isStreamIQ, isToya } from '@/shared/lib'

export const getFavouritesService = async () => {
    if (isToya()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/toya/features/favourites/FavoritesRepositoryToya')
            return module.default
        } catch (error) {
            console.warn(
                'useFavorites module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/features/Favorites/FavoritesRepositoryStreamIQ')
            return module.FavoritesRepositoryStreamIQ
        } catch (error) {
            console.warn(
                'useFavorites module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
